export const accessToken =
    process.env.NODE_ENV === "development"
        ? "pk.eyJ1IjoibWFyY29sYXJvc2EiLCJhIjoiY2pvM2pjMW9kMHhmODNxcmxsMTd2cWkzcCJ9.jpWvN4mzM5M6ijwkSI2CfA"
        : "pk.eyJ1IjoibmljaG9sYXN0IiwiYSI6ImNraW5wbXEzMzBvNTEycW53N2U4MTkycm8ifQ.zrVr4UKn2XETA50ywLxILA";

export const mapBoxStyle = "mapbox://styles/marcolarosa/ckdxwicb42opj19mu7tlt23hn";
